<template>
  <v-container>
    <v-row class="pa-0 mb-n11">
      <v-col cols="9" class="d-flex flex-row">
      <v-text-field class="input-text-size pt-0 pb-0"
      :value="getSelectedTaxType" label="Tax Type" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0"
      :value="mainCompItem.taxYear" label="Tax Year" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0 mr-2"
        :value="mainCompItem.taxId" label="Tax ID" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0 mr-2" label="Base ID"
      :value="mainCompItem.baseId" readonly tabindex="-1" />
      <v-text-field class="input-text-size pt-0 pb-0"
      :value="mainCompItem.ownerId" label="Owner ID" readonly tabindex="-1" />
    </v-col>
    <v-col cols="3">
      <v-text-field class="input-text-size pt-0 pb-0" v-model="mainCompItem.propertyOrParcelId"
        label="Property/Parcel ID" readonly tabindex="-1" />
    </v-col>
    </v-row>
    <v-row dense class="mt-6 mb-n2">
      <v-col cols="12">
        <v-btn-toggle v-model="view" mandatory dense rounded color="primary">
          <v-btn small value="tax">Tax History</v-btn>
          <v-btn small value="owner">Owner/Address History</v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <!-- The yearly tax grid is unchanged; v-show rather than v-if so switching views does
         not re-mount it and lose the scroll position / sort the user set. -->
    <CRUDList
        v-show="view === 'tax'"
        ref="crudList"
        :canAdd="false"
        :canEdit="false"
        :canSave="false"
        :canDeleteInDialog="false"
        :showSelect="false"
        :enableFixedHeaders="true"
        :displayTopPagination="false"
        :hideDefaultFooter="true"
        :disableKeyboardFunc="true"
        :headers="headers"
        :baseCrudKey="baseCrudKey"
        :defaultSortBy="defaultSortBy"
        :overrideValidation="true"
        tableWrapperDynamicClassname='taxroll-table-wrapper-two'
        tableDynamicHeight="200"
      >
      </CRUDList>
    <!-- v-if, unlike the grid above: mounting is what fetches the owner comments, and there
         is no reason to run that query for someone who never opens the view. -->
    <OwnerHistoryList v-if="view === 'owner'" :taxRecords="taxRecords" />
  </v-container>
</template>

<script>
import {
  mapActions, mapState, mapGetters,
} from 'vuex';
import CRUDList from '../../../common/base/crud-2.0/CRUDList.vue';
import OwnerHistoryList from './OwnerHistoryList.vue';
import { HistoryTransactionListHeader } from '../TaxInquiryUtils/TableHeaders.utils';
import '../../../../assets/style.css';

export default {
  name: 'HistoryTransactionList',
  components: {
    CRUDList,
    OwnerHistoryList,
  },
  data() {
    return {
      baseCrudKey: 'historyTransactionListBaseCrudKey',
      headers: HistoryTransactionListHeader,
      view: 'tax',
    };
  },
  computed: {
    ...mapGetters('auth/token', ['authUser']),
    ...mapState({
      TaxTypeEnum: (state) => state.enums.TaxTypeEnum,
    }),
    ...mapGetters('base/crud', ['criteria', 'items', 'item']),
    itemsGetter() {
      const itemData = this.item(this.baseCrudKey);
      return itemData;
    },
    mainCompItem: {
      get() {
        return this.item(this.mainCompBaseCrudKey);
      },
      set(value) {
        this.setItem([this.mainCompBaseCrudKey, value]);
      },
    },
    criteriaState: {
      get() {
        return this.criteria(this.baseCrudKey);
      },
      set(value) {
        this.setCriteria([this.baseCrudKey, value]);
      },
    },
    getSelectedTaxType() {
      const selVal = (this.TaxTypeEnum || []).find((ft) => ft.name === this.mainCompItem.taxType);
      if (selVal && selVal.name) return `${selVal.name} - ${selVal.description}`;
      return '';
    },
    defaultSortBy() {
      return [
        {
          column: 'createdAt',
          direction: 'desc',
        },
      ];
    },
    // The year list the yearly grid is already showing - one entry per tax record found for
    // this property. taxId is carried along because it is not the same in every year: for
    // Tulsa parcel 21825-03-17-04060 it is 421930 for 2022-2025 but 422980 in 2021.
    taxRecords() {
      return (this.items(this.baseCrudKey) || [])
        .filter((rec) => rec && rec.taxYear && rec.taxId)
        .map(({ taxYear, taxId }) => ({ taxYear: Number(taxYear), taxId: Number(taxId) }));
    },
  },
  props: {
    selectedRowItem: {
      type: Object,
      default: () => {},
    },
    mainCompBaseCrudKey: {
      type: String,
      default: 'mainCompBaseCrudKey',
    },
  },
  methods: {
    ...mapActions('tax/taxComments', ['loadTaxComments', 'upsertTaxCommentTrans', 'deleteTaxComments']),
  },
};
</script>
